import { Injectable } from '@angular/core'

import { SupervisorSkill } from './supervisor-skill'

@Injectable()
export class SupervisorSkillSerializer {
  fromJson(json: any): SupervisorSkill {
    const supervisorSkill = {
      ...json
    }

    return supervisorSkill
  }

  toJson(supervisorSkill: SupervisorSkill): any {
    return {
      ...supervisorSkill
    }
  }
}
